import React, { useState, useRef, useEffect } from 'react';
import { Pencil } from 'lucide-react';

interface Props {
  value:     string;
  onChange:  (value: string) => void;
  className?: string;
  disabled?:  boolean;
}

export default function InlineEdit({ value, onChange, className, disabled }: Props) {
  const [editing, setEditing] = useState(false);
  const [draft,   setDraft]   = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [editing]);

  // Read-only mode for viewers
  if (disabled) {
    return (
      <span className={className}>
        {value || <span className="inline-edit-placeholder">—</span>}
      </span>
    );
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        className={`inline-edit-input ${className ?? ''}`}
        value={draft}
        onChange={e => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={e => {
          if (e.key === 'Enter') { e.preventDefault(); commit(); }
          if (e.key === 'Escape') cancel();
        }}
      />
    );
  }

  return (
    <span
      className={`inline-edit-trigger ${className ?? ''} ${!value ? 'inline-edit-empty' : ''}`}
      onClick={startEdit}
      title="Clique para editar"
    >
      {value || <span className="inline-edit-placeholder">—</span>}
      <Pencil size={11} className="inline-edit-icon" />
    </span>
  );

  function startEdit() { setDraft(value); setEditing(true); }
  function commit() {
    const trimmed = draft.trim();
    if (trimmed && trimmed !== value) onChange(trimmed);
    setEditing(false);
  }
  function cancel() { setEditing(false); }
}
